import "./App.css";
import { history } from "./history";
import { Router, Switch, Route } from "react-router-dom";
import React, { lazy, Suspense, Component } from "react";
import Header from "./components/Header";
import Sidebar from "./components/SideBar/Sidebar";
import { showConsole } from "./config/config";
import { PrivateRoute } from "./route/privateRoute";
import AnalyticsDashboard from "./components/AnalyticsDashboard/index.js";
import ScheduleMaster from "./components/ScheduleMaster/index.js";

const DisengargedTrip = lazy(
  () => import("./components/DisengargedTrip/DisengargedTrip"),
);
const DesengargedDailyReports = lazy(
  () => import("./components/TripManagement/TripStoplocation"),
);

const TripStoplocation = lazy(
  () => import("./components/TripManagement/TripStoplocation"),
);
const Login = lazy(() => import("./components/Login"));
const UserList = lazy(() => import("./components/UserManagement/userList"));
const AddUser = lazy(() => import("./components/UserManagement/addUser"));
const Users = lazy(() => import("./components/UserManagement/viewUser"));
const AddSite = lazy(() => import("./components/Site/addSite"));
const AddFPL = lazy(() => import("./components/FPL/addSite"));
const AddDPL = lazy(() => import("./components/DPL/AddDPL"));

const VehicleList = lazy(
  () => import("./components/VehicleManagement/vehicleList"),
);
const AddVehicle = lazy(
  () => import("./components/VehicleManagement/addVehicle"),
);
const Vendors = lazy(() => import("./components/VendorManagement/viewVendor"));
const VendorList = lazy(
  () => import("./components/VendorManagement/vendorList"),
);
const AddVendor = lazy(() => import("./components/VendorManagement/addVendor"));
const Zones = lazy(() => import("./components/ZoneManagement/viewZone"));
const ZoneList = lazy(() => import("./components/ZoneManagement/ZoneList"));
const AddZone = lazy(() => import("./components/ZoneManagement/addZone"));
const Emergencies = lazy(
  () => import("./components/EmergencyManagement1/viewEmergency"),
);
const EmergencyList = lazy(
  () => import("./components/EmergencyManagement1/emergencylist"),
);
const AddEmergency = lazy(
  () => import("./components/EmergencyManagement1/addEmergency"),
);
const WardList = lazy(
  () => import("./components/WardManagement/WardManagement"),
);
const AddWard = lazy(() => import("./components/WardManagement/AddWard"));
const constituencyView = lazy(
  () => import("./components/ConstituencyComponents/viewEmergency"),
);
const constituencyList = lazy(
  () => import("./components/ConstituencyComponents/emergencylist"),
);
const constituencyAdd = lazy(
  () => import("./components/ConstituencyComponents/addEmergency"),
);
const Vehicles = lazy(
  () => import("./components/VehicleManagement/viewVehicle"),
);
const RouteList = lazy(() => import("./components/RouteManagement/routeList"));
const AddRoute = lazy(() => import("./components/RouteManagement/addRoute"));
const ViewRoute = lazy(() => import("./components/RouteManagement/viewRoute"));
const TripList = lazy(() => import("./components/TripManagement/tripList"));
const ViewTrip = lazy(() => import("./components/TripManagement/viewTrip"));
const AddTrip = lazy(() => import("./components/TripManagement/addTrip"));
const preApprovalList = lazy(
  () =>
    import("./components/PreApprovalTripManagement/preapprovalTripApproval"),
);
const AddpreApproval = lazy(
  () => import("./components/PreApprovalTripManagement/addTripSchedule"),
);

const TripDashBoardList = lazy(
  () => import("./components/TripScheduleManagement/DasboardTrips"),
);
const TripScheduleList = lazy(
  () => import("./components/TripScheduleManagement/tripScheduleList"),
);
const ViewTripSchedule = lazy(
  () => import("./components/TripScheduleManagement/viewTripSchedule"),
);
const AddTripSchedule = lazy(
  () => import("./components/TripScheduleManagement/addTripSchedule"),
);
const EditTripSchedule = lazy(
  () => import("./components/TripScheduleManagement/editTripSchedule"),
);
const CompletedTripSchedule = lazy(
  () => import("./components/TripScheduleManagement/completedTrips"),
);
const MissedTripSchedule = lazy(
  () => import("./components/TripScheduleManagement/missedTrips"),
);
const MissedTripApproval = lazy(
  () => import("./components/TripScheduleManagement/missedTripApproval"),
);
const TripsList = lazy(
  () => import("./components/TripScheduleManagement/tripList"),
);
const OperationsDashboard = lazy(
  () => import("./components/TripScheduleManagement/operations-dashboard.js"),
);
const Reports = lazy(() => import("./components/Reports/report"));
const SiteManagement = lazy(() => import("./components/Site/siteManagement"));
const FPLManagement = lazy(() => import("./components/FPL/siteManagement"));
const ViewUser = lazy(() => import("./components/Site/viewUser"));
const LiveTracking = lazy(() => import("./components/Tracking/live"));
const GuestLiveTracking = lazy(
  () => import("./components/guestTracking/history"),
);

const HistoryTracking = lazy(() => import("./components/Tracking/history"));
const Dashboard = lazy(() => import("./components/Dashboard/dashboard"));
const DivisonMangement = lazy(
  () => import("./components/Divison_Management/Index.js"),
);
const AllReportPage = lazy(
  () => import("./components/ReportsGps/AllReportPage"),
);
const FuelReport = lazy(() => import("./components/FuelReports/report"));
const FuelDashboard = lazy(() => import("./components/FuelReports/dashboard"));
const KMLView = lazy(() => import("./components/kmlFile/index"));
const Alerts = lazy(() => import("./components/Alerts/index"));
const SummaryReportPage = lazy(
  () => import("./components/ReportsGps/SummaryReportPage"),
);
const MovementReportPage = lazy(
  () => import("./components/ReportsGps/Movement"),
);
const StopReportPage = lazy(
  () => import("./components/ReportsGps/StopReportPage"),
);
// const TankerTrips =lazy(()=>import ('./components/DReports/SummaryReportPage'))
// const MovementReportPage =lazy(()=>import ('./components/ReportsGps/Movement'))
// const StopReportPage =lazy(()=>import ('./components/ReportsGps/StopReportPage'))
const tripMap = lazy(() => import("./components/TripManagement/tripMaps"));
const ReportMapDetails = lazy(
  () => import("./components/Reports/reportMapDetails"),
);
const TankerTripPerformanceReport = lazy(
  () => import("./components/DReports/SummaryReportPage"),
);

const TankerPerformanceReport = lazy(
  () => import("./components/DReports/SummaryReportPage"),
);
const AgencyPerformanceReport = lazy(
  () => import("./components/DReports/SummaryReportPage"),
);
const EmergencyPerformanceReport = lazy(
  () => import("./components/DReports/SummaryReportPage"),
);
// const TankerTripPerformanceReportPage =lazy(()=>import ('./components/DjbReports/tankerTripsPerformance'))
// const TankerPerformanceReportPage =lazy(()=>import ('./components/DjbReports/tankerPerformance'))
// const AgencyPerformanceReportPage =lazy(()=>import ('./components/DjbReports/agencyPerformance'))
// const EmergencyPerformanceReportPage  =lazy(()=>import ('./components/DjbReports/emergencyPerformance'))

// const tripMap =lazy(()=>import ('./components/TripManagement/tripMaps'))
const AgreementLIst = lazy(
  () => import("./components/AgreementManagement/AgreementList"),
);
const AgreementAdd = lazy(
  () => import("./components/AgreementManagement/addAgreement"),
);

const AgreementView = lazy(
  () => import("./components/AgreementManagement/viewAgreement"),
);
const DailySummaryReportPage = lazy(
  () => import("./components/ReportsGps/DailySummaryReportPage"),
);
const ScheduleDistanceReport = lazy(
  () => import("./components/ReportsGps/ScheduleDistanceReport"),
);

// const DailySummaryReportPage  = lazy(()=>import ('./components/ReportsGps/DailySummaryReportPage'))

// const DailySummaryReportPage  = lazy(()=>import (`${decryptAesObj(localStorage.getItem("data")).companyId}=="5"?'./components/ReportsGps/DailySummaryReportPage':${decryptAesObj(localStorage.getItem("data")).companyId}==1?'./components/ReportsGps/DailySummaryReportPage':""`))

const ErrorPage = lazy(() => import("./components/ErrorPage"));
const UpdateDistance = lazy(
  () => import("./components/Update_Distance/UpdateDistance"),
);
const DuplicateReports = lazy(
  () => import("./components/ReportsGps/DuplicateReports"),
);
const DplList = lazy(() => import("./components/DplManagement/DplList"));
const SchedulTripList = lazy(
  () => import("./components/DplManagement/SchedulTripList"),
);
const DynamicManagement = lazy(
  () => import("./components/DynamicMangement/DynamicMangement.js"),
);

const TripScheduleLists = lazy(
  () => import("./components/DplManagement/TripScheduleList"),
);
const QrCodeInfo = lazy(() => import("./components/ReportsGps/QrCodeInfo"));

const ApiLogsList = lazy(() => import("./components/Logs/index.js"));
const GPSTrailImport = lazy(
  () => import("./components/GPSTrailImport/index.js"),
);

const TokenManagment = lazy(
  () => import("./components/tokenManagement/index.js"),
);
const AddToken = lazy(() => import("./components/tokenManagement/addToken.js"));
const PerformanceScore = lazy(()=>import("./components/PerformanceScore"))

class App extends Component {
  render() {
    // if (showConsole) {
    //   console.log = () => {};
    //   console.error = () => {};
    //   console.debug = () => {};
    //   console.warn = () => {};
    // }
    // checkLoginTime(new Date());
    return (
      <main className="App">
        <Router history={history}>
          {window.location.pathname !== "/" &&
            window.location.pathname !== "/alerts" &&
            window.location.pathname !== "/error" && (
              <>
                <Header />
                {window.location.pathname !== "/guestTracking" && <Sidebar />}
              </>
            )}

          <Suspense fallback={<div>Loading</div>}>
            <Switch>
              <Route exact path="/" component={Login} />
              <PrivateRoute exact path="/userlist" component={UserList} />
              <PrivateRoute exact path="/adduser" component={AddUser} />
              <PrivateRoute exact path="/users/:id?" component={Users} />
              <PrivateRoute exact path="/vehiclelist" component={VehicleList} />
              <PrivateRoute exact path="/addvehicle" component={AddVehicle} />
              <PrivateRoute exact path="/vehicles/:id?" component={Vehicles} />
              <PrivateRoute
                exact
                path="/transporters/:id?"
                component={Vendors}
              />
              <PrivateRoute
                exact
                path="/transporterlist"
                component={VendorList}
              />
              <PrivateRoute
                exact
                path="/addtransporter"
                component={AddVendor}
              />
              <PrivateRoute exact path="/zones/:id?" component={Zones} />
              <PrivateRoute exact path="/zonelist" component={ZoneList} />
              <PrivateRoute exact path="/addzone" component={AddZone} />
              <PrivateRoute
                exact
                path="/Emergencies/:id?"
                component={Emergencies}
              />
              <PrivateRoute
                exact
                path="/emergencylist"
                component={EmergencyList}
              />
              <PrivateRoute
                exact
                path="/addEmergency"
                component={AddEmergency}
              />
              <PrivateRoute exact path="/wardlist" component={WardList} />
              <PrivateRoute exact path="/addward" component={AddWard} />
              <PrivateRoute exact path="/addward/:id?" component={AddWard} />
              <PrivateRoute
                exact
                path="/constituency/:id?"
                component={constituencyView}
              />
              <PrivateRoute
                exact
                path="/constituencyList"
                component={constituencyList}
              />
              <PrivateRoute
                exact
                path="/addconstituency"
                component={constituencyAdd}
              />
              {/* <Route exact path='/emergencydetail' component={EmergencyDetail} /> */}
              <PrivateRoute exact path="/routelist" component={RouteList} />
              <PrivateRoute exact path="/addroute" component={AddRoute} />
              <PrivateRoute exact path="/routes/:id?" component={ViewRoute} />
              <PrivateRoute exact path="/triplist" component={TripList} />
              <PrivateRoute
                exact
                path="/DisengagedTrip"
                component={DisengargedTrip}
              />
              <PrivateRoute exact path="/addtrip" component={AddTrip} />
              <PrivateRoute exact path="/trips/:id?" component={ViewTrip} />
              <PrivateRoute
                exact
                path="/tripStatus"
                component={TripDashBoardList}
              />
              <PrivateRoute
                exact
                path="/tripSchedulelist"
                component={TripScheduleList}
              />
              <PrivateRoute
                exact
                path="/addTripSchedule"
                component={AddTripSchedule}
              />
              <PrivateRoute
                exact
                path="/editTripSchedule"
                component={EditTripSchedule}
              />
              <PrivateRoute
                exact
                path="/viewtripSchedule"
                component={ViewTripSchedule}
              />
              <PrivateRoute
                exact
                path="/completedTrips"
                component={CompletedTripSchedule}
              />
              <PrivateRoute
                exact
                path="/missedTrips"
                component={MissedTripSchedule}
              />
              <PrivateRoute
                exact
                path="/missedTripApproval"
                component={MissedTripApproval}
              />
              <PrivateRoute exact path="/tripslist" component={TripsList} />
              <PrivateRoute
                exact
                path="/operations-dashboard"
                component={ErrorPage}
              />
              <PrivateRoute exact path="/reports" component={Reports} />
              <PrivateRoute
                exact
                path="/deliverylist"
                component={SiteManagement}
              />
              <PrivateRoute exact path="/sitelist" component={SiteManagement} />
              <PrivateRoute exact path="/fpllist" component={FPLManagement} />
              <PrivateRoute exact path="/viewUser/:id?" component={ViewUser} />
              <PrivateRoute exact path="/delivery/:id?" component={AddSite} />
              <PrivateRoute exact path="/fpl/:id?" component={AddFPL} />
              <PrivateRoute exact path="/dpl/:id?" component={AddDPL} />
              <PrivateRoute exact path="/adddelivery" component={AddSite} />
              <PrivateRoute exact path="/addfpl" component={AddFPL} />
              <PrivateRoute exact path="/live/:id?" component={LiveTracking} />
              <Route
                exact
                path="/guestTracking"
                component={GuestLiveTracking}
              />
              <PrivateRoute
                exact
                path="/history/:id?"
                component={HistoryTracking}
              />
              <PrivateRoute exact path="/dashboard" component={Dashboard} />
              <PrivateRoute
                exact
                path="/divisonList"
                component={DivisonMangement}
              />
              <PrivateRoute
                exact
                path="/Reportsgps"
                component={AllReportPage}
              />
              <PrivateRoute exact path="/fuelReport" component={FuelReport} />
              <PrivateRoute
                exact
                path="/fuelDashboard"
                component={FuelDashboard}
              />
              <PrivateRoute exact path="/kmlview" component={KMLView} />
              <PrivateRoute exact path="/alerts" component={Alerts} />
              {/* <Route exact path='/tankerTrip' component={TankerTrips} /> */}
              <PrivateRoute
                exact
                path="/Summary"
                component={SummaryReportPage}
              />
              <PrivateRoute
                exact
                path="/Movement"
                component={MovementReportPage}
              />
              <PrivateRoute exact path="/Stoppage" component={StopReportPage} />
              <PrivateRoute
                exact
                path="/reportDetails"
                component={ReportMapDetails}
              />
              {/* <Route exact path='/tankerTripsPerformance' component={TankerTripPerformanceReportPage} />
            {/* <Route exact path='/tankerPerformance' component={TankerPerformanceReportPage} /> */}
              <PrivateRoute
                exact
                path="/tankerTripPerformance"
                component={TankerTripPerformanceReport}
              />
              <PrivateRoute
                exact
                path="/tankerPerformance"
                component={TankerPerformanceReport}
              />
              <PrivateRoute
                exact
                path="/agencyPerformance"
                component={AgencyPerformanceReport}
              />
              <PrivateRoute
                exact
                path="/emergencyPerformance"
                component={EmergencyPerformanceReport}
              />
              <PrivateRoute exact path="/tripTrack/:id?" component={tripMap} />
              <PrivateRoute exact path="/audit" component={Reports} />
              <PrivateRoute exact path="/activeRoutes" component={Reports} />
              <PrivateRoute exact path="/upTime" component={Reports} />
              <PrivateRoute exact path="/penalty" component={Reports} />
              <PrivateRoute exact path="/agreement" component={AgreementLIst} />
              <PrivateRoute
                exact
                path="/depotlist"
                component={DynamicManagement}
              />
              {/* <PrivateRoute exact path="/:listType" component={DynamicManagement} /> */}
              <PrivateRoute
                exact
                path="/addagreement"
                component={AgreementAdd}
              />
              <PrivateRoute
                exact
                path="/viewagreement/:id?"
                component={AgreementView}
              />
              <PrivateRoute
                exact
                path="/preApprovalList"
                component={preApprovalList}
              />
              <PrivateRoute
                exact
                path="/addpreApproval"
                component={AddpreApproval}
              />
              <PrivateRoute
                exact
                path="/DailyDistance"
                component={DailySummaryReportPage}
              />
              <PrivateRoute
                exact
                path="/DisengagedDaily"
                component={DailySummaryReportPage}
              />
              {/* <PrivateRoute
                exact
                path="/DisengagedDaily"
                component={DesengargedDailyReports}
              /> */}
              <PrivateRoute
                exact
                path="/ScheduleDistance"
                component={ScheduleDistanceReport}
              />
              <PrivateRoute
                exact
                path="/singleDistance"
                component={DailySummaryReportPage}
              />
              <PrivateRoute
                exact
                path="/updateDistance"
                component={UpdateDistance}
              />
              <Route exact path="/error" component={ErrorPage} />
              {/* <Route exact path="/TripStoplocation/:lat/:long/:duration/:stopNumber?" component={TripStoplocation} /> */}
              <PrivateRoute
                exact
                path="/TripStoplocation/"
                component={TripStoplocation}
              />
              <PrivateRoute
                exact
                path="/duplicate/"
                component={DuplicateReports}
              />
              <PrivateRoute exact path="/dplManagement/" component={DplList} />
              <PrivateRoute
                exact
                path="/tripSchedule/"
                component={SchedulTripList}
              />
              <PrivateRoute
                exact
                path="/tripScheduleLists/:type?"
                component={TripScheduleLists}
              />

              <PrivateRoute
                exact
                path="/analytics-dashboard"
                component={AnalyticsDashboard}
              />

              <Route path="/logs" component={ApiLogsList} />
              <Route path="/GPSTrailImport" component={GPSTrailImport} />
              {/* Public route for QR code scanning - accessible without login */}
              <Route path="/qr/:qrCode" component={QrCodeInfo} />
              <PrivateRoute
                exact
                path="/token-management"
                component={TokenManagment}
              />
              <PrivateRoute
                exact
                path="/schedule-master"
                component={ScheduleMaster}
              />
               <PrivateRoute
                exact
                path="/performance-score"
                component={PerformanceScore}
              />
              <Route path="/addToken" exact component={AddToken} />{" "}
              {/* For adding new */}
              <Route path="/viewToken" component={AddToken} />
            </Switch>
          </Suspense>
        </Router>
      </main>
    );
  }
}
export default App;
